import * as React from "react";

import { ErrorText } from "./ZeroReporting.styles";

export function ZeroReportExceptionInfo(): JSX.Element {
    return (
        <ErrorText>
            Не удалось заполнить черновик.
            <br />
            Повторите попытку через несколько минут. Если ошибка повторяется, напишите в техподдержку.
        </ErrorText>
    );
}
